export { default } from './List';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/List/index.js
// module id = 454
// module chunks = 121